import { all, call, spawn } from 'redux-saga/effects';
import alertsSaga from './alerts';
import appSaga from './app';
import attachmentsSaga from './attachments';
import authSaga from './auth';
import directChatSaga from './direct-chat';
import eVisitsSaga from './e-visits';
import eventsSaga from './events';
import lifeIdSaga from './life-id';
import medicalInstitutions from './medial-institutions';
import newsSaga from './news';
import patientsSaga from './patients';
import programsSaga from './programs';
import questionnairesSaga from './questionnaires';
import reservationFormSaga from './reservation-form/reservation-form-saga';
import roomsSaga from './rooms';
import tagsPageSaga from './tags-page';
import twilioSaga from './twilio';
import usersSaga from './users';
import vitalHistorySaga from './vital-history';
import xmppSaga from './xmpp';

const sagas = [
  authSaga,
  usersSaga,
  xmppSaga,
  directChatSaga,
  medicalInstitutions,
  patientsSaga,
  alertsSaga,
  newsSaga,
  roomsSaga,
  questionnairesSaga,
  lifeIdSaga,
  vitalHistorySaga,
  attachmentsSaga,
  eventsSaga,
  eVisitsSaga,
  tagsPageSaga,
  reservationFormSaga,
  appSaga,
  programsSaga,
  twilioSaga,
];

function* rootSaga() {
  yield all(
    sagas.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            console.log('Root saga uncaught error', e);
          }
        }
      }),
    ),
  );
}

export default rootSaga;
